import axios from "axios";
import { API_URL } from "@/config";
import { resetStateToDefault } from "@/lib/store/index";

const defaultState = Object.freeze({
  options: [],
});

const store = {
  namespaced: true,

  state: {
    ...defaultState,
  },

  getters: {
    hasOptions(state) {
      return state.options.length > 0;
    },
  },

  mutations: {
    setOptions(state, options) {
      state.options = options;
    },

    clearOptionsCache(state) {
      state.options = [];
    },

    resetState(state) {
      resetStateToDefault(state, defaultState);
    },
  },

  actions: {
    async getMany(_, { filters, page }) {
      const res = await axios.get(`${API_URL}/inventory/ingredients/categories`, {
        params: { ...filters, page },
      });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, ingredientCategoryId) {
      const res = await axios.get(
        `${API_URL}/inventory/ingredients/categories/${ingredientCategoryId}`,
      );

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create({ commit }, ingredientCategoryData) {
      const res = await axios.post(
        `${API_URL}/inventory/ingredients/categories`,
        ingredientCategoryData,
      );

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return res.data;
    },

    async update({ commit }, { ingredientCategoryId, ingredientCategoryData }) {
      const res = await axios.put(
        `${API_URL}/inventory/ingredients/categories/${ingredientCategoryId}`,
        ingredientCategoryData,
      );

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return res.data;
    },

    async remove({ commit }, ingredientCategoryId) {
      // Let the original AxiosError propagate so the caller can check error.response?.status
      // (e.g. 409 when category is still assigned to an ingredient)
      const res = await axios.delete(
        `${API_URL}/inventory/ingredients/categories/${ingredientCategoryId}`,
      );

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return true;
    },

    async getOptions({ commit, state }) {
      if (state.options?.length) {
        return state.options;
      }

      const response = await axios.get(`${API_URL}/inventory/ingredients/categories/options`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("setOptions", response.data);

      return response.data;
    },
  },
};

export default store;
